import * as React from "react";
import * as RadixLabel from "@radix-ui/react-label";
import { cn } from "@/components/lib/utils";

const Label = React.forwardRef<
  React.ElementRef<typeof RadixLabel.Root>,
  React.ComponentPropsWithoutRef<typeof RadixLabel.Root> & { snaplandId?: string }
>(({ className, snaplandId, ...props }, ref) => (
  <RadixLabel.Root
    ref={ref}
    className={cn(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 block rtl:text-right rtl:[direction:rtl]",
      className
    )}
    data-snapland-id={snaplandId || "label"}
    {...props}
  />
));
Label.displayName = RadixLabel.Root.displayName;

export { Label };

